import { IsUUID } from 'class-validator';

export class IdParamsDto {
  @IsUUID()
  public id!: string;
}
